import { render, staticRenderFns } from "./HomeNewsSwipper.vue?vue&type=template&id=703bbcd0&scoped=true&"
import script from "./HomeNewsSwipper.vue?vue&type=script&lang=ts&"
export * from "./HomeNewsSwipper.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNewsSwipper.vue?vue&type=style&index=0&id=703bbcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703bbcd0",
  null
  
)

export default component.exports